var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.34014 2.36983C11.2471 4.19627 11.2471 7.15377 9.34014 8.98021C7.43322 10.8038 4.33976 10.8038 2.42981 8.98021C0.522891 7.15377 0.522891 4.19338 2.43284 2.36983C4.33976 0.54339 7.43322 0.54339 9.34014 2.36983Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8048 12.3099C14.0651 12.5581 14.0651 12.962 13.8048 13.2102L13.7563 13.2563C13.496 13.5045 13.0753 13.5045 12.815 13.2563L8.84375 9.4563L9.83051 8.51279L13.8048 12.3128V12.3099Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchBlack);
export default __webpack_public_path__ + "static/media/search-black.17aa2615d8e49bb12930645b9a50f0a3.svg";
export { ForwardRef as ReactComponent };